import { render, staticRenderFns } from "./BannerContentType.vue?vue&type=template&id=232410c0&scoped=true"
import script from "./BannerContentType.vue?vue&type=script&lang=js"
export * from "./BannerContentType.vue?vue&type=script&lang=js"
import style0 from "./BannerContentType.vue?vue&type=style&index=0&id=232410c0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232410c0",
  null
  
)

export default component.exports